export default {
      id: "Icon--figure-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--figure",
      toString: function () {
        return this.url;
      }
    }